import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterTableData'
})
export class FilterTableDataPipe implements PipeTransform {
  transform(data: any[], filter: string): any[] {
    if (!data || !filter) {
      return data;
    }
    filter = filter.toLowerCase();
    return data.filter((item) => item.companyName.toLowerCase().includes(filter));
    // Replace 'companyName' with the property you want to filter by
  }
}
